export default "__VITE_ASSET__Wacss9_L__"